import { Link } from 'react-router-dom';
import { useWishlist } from '../state/wishlist';
import { useCart } from '../state/cart';

const DEFAULT_STOCK = 20;

export function WishlistPage() {
  const { items, wishlistCount, removeWishlist } = useWishlist();
  const { addItem } = useCart();

  return (
    <section className="section-padding elenardSectionTight">
      <div className="container">
        <div className="sec-head mb-30">
          <span className="sub-title main-color mb-10">Wishlist</span>
          <h3 className="fw-600 fz-50 text-u">
            Saved <span className="fw-200">pieces</span>
          </h3>
          <div className="opacity-8 fz-14 mt-10">{wishlistCount} item(s)</div>
        </div>

        {items.length === 0 ? (
          <div className="elenardCartEmpty item" style={{ padding: 18 }}>
            <h5 className="mb-10">Your wishlist is empty</h5>
            <p className="opacity-8 mb-20">
              Tap the heart on a product to save it here — same idea as on{' '}
              <a
                className="main-color"
                href="https://elenard.com/shop/"
                target="_blank"
                rel="noreferrer"
              >
                elenard.com/shop
              </a>
              .
            </p>
            <Link to="/shop" className="butn butn-md butn-bg main-colorbg radius-30">
              <span className="text">Browse shop</span>
            </Link>
          </div>
        ) : (
          <div className="row">
            {items.map((p) => (
              <div key={p.id} className="col-lg-4 col-md-6 mb-30">
                <div className="item elenardProductCard">
                  <div className="img position-relative">
                    <Link to={`/product/${p.slug}`}>
                      <img
                        src={p.image || '/assets/imgs/logo-light.svg'}
                        alt={p.name}
                        className="elenardProductImg"
                        loading="lazy"
                      />
                    </Link>
                  </div>
                  <div className="cont mt-20 elenardProductCont">
                    <h6 className="mb-10 elenardProductTitle">{p.name}</h6>
                    <div className="elenardPriceRow">
                      <div className="elenardPrice">
                        {p.priceText ||
                          (Number.isFinite(p.price) ? `$${Number(p.price).toFixed(2)}` : '')}
                      </div>
                    </div>
                    <div className="mt-15" style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                      <Link
                        to={`/product/${p.slug}`}
                        className="butn butn-sm butn-bord radius-30"
                      >
                        <span className="text">View product</span>
                      </Link>
                      <button
                        type="button"
                        className="butn butn-sm butn-bg main-colorbg radius-30"
                        disabled={p.outOfStock}
                        onClick={() => {
                          addItem({
                            id: p.id,
                            name: p.name,
                            price: p.price,
                            qty: 1,
                            image: p.image,
                            maxQty: DEFAULT_STOCK,
                          });
                        }}
                      >
                        <span className="text">{p.outOfStock ? 'Sold out' : 'Add to cart'}</span>
                      </button>
                      <button
                        type="button"
                        className="butn butn-sm butn-bord radius-30"
                        onClick={() => removeWishlist(p.id)}
                      >
                        <span className="text">Remove</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
